import type { FC, PropsWithChildren } from 'react';
import { memo } from 'react';

import ConferenceStore from './conference';
import ControlsStore from './controls';
import CurrentUserStore from './currentUser';
import DebugStore from './debug';
import SizeStore from './size';
import TimerStore from './timer';
import UsersStore from './users';

const Store: FC<PropsWithChildren> = ({ children }) => {
    return (
        <DebugStore>
            <SizeStore>
                <CurrentUserStore>
                    <ConferenceStore>
                        <UsersStore>
                            <TimerStore>
                                <ControlsStore>{children}</ControlsStore>
                            </TimerStore>
                        </UsersStore>
                    </ConferenceStore>
                </CurrentUserStore>
            </SizeStore>
        </DebugStore>
    );
};

export default memo(Store);
